import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-bottombar',
    templateUrl: './bottombar.component.html',
    styleUrls: ['./bottombar.component.scss'],
    standalone: false
})
export class BottombarComponent implements OnInit {
  public currentDate = new Date();
  public currentYear = this.currentDate.getFullYear();

  constructor() { }

  ngOnInit() {
  }

}
